// Colores del sistema de diseño de la app (tokens de App.css)
const PALETTE = [
	{ bg: '#dbe7ff', color: '#124fc9' }, // azul-50 / azul-400
	{ bg: '#c1d5fe', color: '#0940ae' }, // azul-100 / azul-500
	{ bg: '#e1fafa', color: '#119997' }, // verde-50 / verde-400
	{ bg: '#bde9e8', color: '#119997' }, // verde-100 / verde-400
	{ bg: '#fff6e8', color: '#e57a00' }, // naranja-50 / naranja-400
	{ bg: '#ffe9e5', color: '#c74028' }, // rojo-50 / rojo-400
]

function getInitials(name) {
	if (!name) return '?'
	const parts = name.trim().split(/\s+/)
	if (parts.length === 1) return parts[0][0].toUpperCase()
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

function pickColor(name) {
	if (!name) return PALETTE[0]
	let hash = 0
	for (let i = 0; i < name.length; i++) {
		hash = name.charCodeAt(i) + ((hash << 5) - hash)
	}
	return PALETTE[Math.abs(hash) % PALETTE.length]
}

export const AvatarInitials = ({ name, size = 28, src = '' }) => {
	const initials = getInitials(name)
	const { bg, color } = pickColor(name)

	return (
		<div
			style={{
				width: size,
				height: size,
				minWidth: size,
				borderRadius: '50%',
				backgroundColor: bg,
				color: color,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				fontSize: Math.round(size * 0.34),
				fontFamily: 'Montserrat, sans-serif',
				fontWeight: 700,
				letterSpacing: '0.5px',
				flexShrink: 0,
				userSelect: 'none',
			}}
		>
			{src ? (
				<img
					src={src}
					alt={name || 'Avatar'}
					style={{
						width: '100%',
						height: '100%',
						borderRadius: '50%',
						objectFit: 'cover',
						display: 'block',
					}}
				/>
			) : (
				initials
			)}
		</div>
	)
}
